module.exports = {
  messages: {
    CN: {
      Create: "创建",
      CustomerSuccess: "AI策略分析",
      askFewQuestions:
        "我会问几个问题来了解您的业务，并推荐如何在LinkedIn上快速达成目标",
      Skipconsultation: "跳过咨询",
      skipBtnText: "跳过咨询，直接创建 →",
      review: "查看",
      thinking: "思考中",
      startAnswering: "开始回答：",
      enterYourQuestion: "在此输入您的问题",
      thankYouForInput: "感谢您的输入，以下是您的定制报告...",
      operationCanceledByUser: "操作已被用户取消。",
      SalesSuccessManager: `您好！我是您的专属客户成功经理。请告诉我您想实现什么目标。例如："我想销售SaaS产品。"`,
      HrSucessMannager: `您好！我是您的专属客户成功经理。请告诉我您想实现什么目标。例如："我想招聘一名后端工程师。"`,
      enterAnswer: "请输入您的回答",
      Send: "发送",
      Great: "太好了！我已收到您的所有信息。正在生成您的定制报告，请稍候…",
      Personalized: "您的个性化咨询报告",
      ReturnConsultation: "返回咨询",
      CreateCampaign: "创建campaign",
      ConsultationReport: "咨询报告",
    },
    US: {
      Create: "Create",
      CustomerSuccess: "AI Strategy Analysis",
      askFewQuestions:
        "I'll ask a few questions to understand your business and recommend how to quickly achieve your goals on LinkedIn",
      Skipconsultation: "Continue Without Consultation",
      skipBtnText: "Skip consultation, create directly →",
      review: "review",
      thinking: "thinking",
      startAnswering: "Start Answering: ",
      enterYourQuestion: "Enter your question here",
      thankYouForInput:
        "Thank you for your input. Here is your customized report...",
      operationCanceledByUser: "Operation canceled by the user.",
      SalesSuccessManager: `Hi there! I'm your dedicated Customer Success Manager. Let me know what you want to achieve. For example, you can say "I want to sell SaaS products."`,
      HrSucessMannager: `Hi! I'm your dedicated Customer Success Manager. Tell me what you want to accomplish. For example, you can say "I want to hire a backend engineer."`,
      enterAnswer: "Please enter your answer",
      Send: "Send",
      Great:
        "Great! I have received all your information. Your custom report is being generated. Please wait a moment.",
      Personalized: "Your Personalized Consultation Report",
      ReturnConsultation: "Return to Consultation",
      CreateCampaign: "Create Campaign",
      ConsultationReport: "Consultation Report",
    },
    AR: {
      Create: "إنشاء",
      CustomerSuccess: "تحليل استراتيجيات الذكاء الاصطناعي",
      askFewQuestions:
        "سأطرح بعض الأسئلة لفهم عملك وأوصي بكيفية تحقيق أهدافك بسرعة على LinkedIn",
      Skipconsultation: "تخطي الاستشارة",
      skipBtnText: "تخطي الاستشارة، أنشئ مباشرةً ←",
      review: "مراجعة",
      thinking: "جاري التفكير",
      startAnswering: "بدء الإجابة: ",
      enterYourQuestion: "أدخل سؤالك هنا",
      thankYouForInput: "شكرًا لإدخالك، إليك تقريرك المخصّص...",
      operationCanceledByUser: "تمّ إلغاء العملية من قِبَل المستخدم.",
      SalesSuccessManager:
        "مرحبًا! أنا مدير نجاح العملاء المخصص لك. يرجى إخباري بما ترغب في تحقيقه. مثال: ‘أريد بيع منتجات SaaS.’",
      HrSucessMannager: `مرحبًا! أنا مُدير نجاح العملاء المخصص لخدمتك. يُرجى إعلامي بما ترغب في تحقيقه.
على سبيل المثال: ‘أرغب في توظيف مهندس نظم خلفية (Backend Engineer)‘`,
      enterAnswer: "الرجاء إدخال إجابتك",
      Send: "إرسال",
      Great:
        "رائع! لقد تلقيت جميع معلوماتك. جاري إنشاء تقريرك المخصص — يرجى الانتظار قليلاً…",
      Personalized: "تقرير الاستشارة الشخصي",
      ReturnConsultation: "العودة إلى الاستشارة",
      CreateCampaign: "إنشاء حملة",
      ConsultationReport: "تقرير الاستشارة",
    },
  },
};
